module.exports = __webpack_public_path__ + "static/media/AIR_AMS_TYPE86_TEMPLATE_SIMPLIFIED.7fb55934.csv";